module.exports = __webpack_public_path__ + "5d7bb6049188ee4b9feecedab540611a.pdf";